/* eslint-disable eqeqeq */
import { useState } from "react";
import { useForm } from "react-hook-form";
// import FormBox from "./Form";

import {
  salDetailsFormOptions,
  salGeneralFormOptions,
  submitALoanFormOptions,
  updatedSALFormInputArr,
} from "./SalConstant";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";
import { LiHandleButton, LoadingButton } from "../../Utils/CustomComponent";
import { Button } from "react-bootstrap";
import FormBox from "../../components/FormBox/FormBox";

const SALForm = () => {
  const [activeTab, setActiveTab] = useState(0);
  const schema = tabButtons.at(activeTab)?.validation
    ? tabButtons.at(activeTab)?.validation
    : null;

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    // ...schema
  });

  const [submitLoading, setSubmitLoading] = useState(false);
  const onSubmit = async (data, func) => {
    // func();
    if (activeTab === 8) {
      setSubmitLoading(true);
      const id = toast.loading("Loan Submission Pending");

      try {
        // const headers = {
        //   headers: {
        //     "Content-Type": "application/json",
        //   },
        // };
        // await axios.post(
        //   urls.submitaLoan.postSubmitaLoan(),
        //   {
        //     user_id: localStorage.getItem("apex_userid"),
        //     loan_submission_details: data,
        //   },
        //   headers
        // );
        toast.update(id, {
          render: "Loan Submitted Succesfuly",
          type: "success",
          isLoading: false,
          ...commonToast,
        });
        setSubmitLoading(false);
      } catch (error) {
        console.error(error);
        toast.update(id, {
          render: "Error",
          type: "error",
          isLoading: false,
          ...commonToast,
        });
      }
    }
  };
  const handleNextClick = () => {
    if (activeTab !== 8) {
      const func = () => setActiveTab((data) => data + 1);
      handleSubmit(onSubmit)(func);
    }
  };
  const handleBtnClick = (value) => {
    const func = () => setActiveTab(value);
    func();
    // handleSubmit(onSubmit)(func);
  };
  const handleBackClick = () => {
    if (activeTab !== 0) {
      setActiveTab((data) => data - 1);
    }
  };
  return (
    <div style={{ overflowY: "scroll" }}>
      <section
        className=" rounded loan-onboarding-form"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <article className="container-fluid">
          <div className="p-3 pb-0  mt-1">
            <h6>
              <a href="/submit-a-loan" style={{ textDecoration: "none" }}>
                Submit a Loan
              </a>{" "}
              / Form
            </h6>
          </div>
        </article>
        <article className="container-fluid">
          <section className="bg-white p-5 my-2 mx-4">
            <div className="row"></div>
            <h4 className="mt-5">Submit a Loan Form</h4>
            <div className="loan-details">
              <div className="pt-5 mt-5">
                <ul className="nav nav-tabs ">
                  {tabButtons?.map((data, index) => (
                    <LiHandleButton
                      key={index}
                      activeTab={activeTab}
                      setActiveTab={setActiveTab}
                      label={data.label}
                      value={index}
                      handleBtnClick={handleBtnClick}
                    />
                  ))}
                </ul>
              </div>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="loans-in-details mt-5">
                {updatedSALFormInputArr?.map((data, index) => {
                  return activeTab == index ? (
                    <RenderComp
                      key={index}
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      options={data.arr}
                      errors={errors}
                    />
                  ) : null;
                })}
                <div className="col-sm-10">
                  {activeTab !== 0 && (
                    <Button onClick={handleBackClick} className="me-2">
                      Back
                    </Button>
                  )}
                  {activeTab !== 8 && (
                    <Button onClick={handleNextClick} className="me-2">
                      Next
                    </Button>
                  )}
                  {activeTab === 8 && (
                    <LoadingButton
                      loading={submitLoading}
                      type="submit"
                      title={"Submit"}
                    />
                  )}
                </div>
              </div>
            </form>
          </section>
        </article>
      </section>
    </div>
  );
};
export default SALForm;
let tabButtons = [
  {
    label: <p>General</p>,
    validation: salGeneralFormOptions,
  },
  {
    label: <p>Details</p>,
    validation: salDetailsFormOptions,
  },
  {
    label: <p>Commercial</p>,
  },
  {
    label: <p>Construction</p>,
  },
  // {
  //   label: <p>Line Of Credit</p>,
  // },
  {
    label: <p>ARM</p>,
  },
  {
    label: <p>GTM</p>,
  },
  {
    label: <p>Penalties</p>,
  },
  {
    label: <p>Escrow Vouchers</p>,
  },
  {
    label: <p>Options</p>,
  },
];
export const RenderComp = ({ options, ...props }) => {
  return (
    <div className="row">
      {options.map((data) =>
        data.subArr ? (
          <NestedTabs {...props} options={data.subArr} />
        ) : (
          <div className={data?.className ? data.className : "col-12"}>
            <h4 className="mt-5 mb-4">{data.section}</h4>
            <FormBox {...props} options={data.arr} />
          </div>
        )
      )}
    </div>
  );
};
const NestedTabs = ({ options, ...props }) => {
  const [activeSubTab, setActiveSubTab] = useState(0);

  const handleBtnClick = (value) => {
    const func = () => setActiveSubTab(value);
    func();
    // handleSubmit(onSubmit)(func);
  };
  return (
    <>
      <>
        <ul className="nav nav-tabs ">
          {options?.map((data, index) => (
            <LiHandleButton
              key={index}
              activeTab={activeSubTab}
              setActiveTab={setActiveSubTab}
              label={data.subArrtitle}
              value={index}
              handleBtnClick={handleBtnClick}
            />
          ))}
        </ul>
        <div className="row">
          {options[activeSubTab].subArrarr.map((nestedTab) =>
            nestedTab?.subArr ? (
              <NestedTabs {...props} options={nestedTab.subArr} />
            ) : (
              <div
                className={
                  nestedTab?.className ? nestedTab.className : "col-12"
                }
              >
                <h4 className="mt-5 mb-4">{nestedTab.section}</h4>
                <FormBox {...props} options={nestedTab.arr} />
              </div>
            )
          )}
        </div>
      </>
    </>
  );
};
